import React, { useState } from 'react';

const ExpandableText = ({ text, maxLength = 60 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  if (!text) return null;
  if (text.length <= maxLength) return <span>{text}</span>;
  return (
    <span className="break-words whitespace-pre-wrap">
      {isExpanded ? text : `${text.substring(0, maxLength)}...`}
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsExpanded(!isExpanded);
        }}
        className="text-blue-500 hover:text-blue-700 font-bold ml-2 text-[10px] uppercase tracking-wider inline-block"
      >
        {isExpanded ? 'Gizle' : 'Devamını Gör'}
      </button>
    </span>
  );
};

export default ExpandableText;
